/**
 * 列表筛选结果总金额展示单位。
 */
export type SearchTotalAmountUnit = "元" | "万元";

/**
 * 列表筛选结果总金额展示结构。
 */
export interface SearchTotalAmountDisplay {
    displayAmount: string;
    displayUnit: SearchTotalAmountUnit;
}

/**
 * 资金列表总金额展示规则：
 * 绝对值小于 10000 显示“元”，绝对值大于等于 10000 显示“万元”。
 */
export function formatSearchTotalAmount(amount: number | null | undefined): SearchTotalAmountDisplay {
    const safeAmount = typeof amount === "number" && Number.isFinite(amount) ? amount : 0;
    // 单位阈值按绝对值判断，但展示金额仍保留原始正负号。
    const absAmount = Math.abs(safeAmount);

    if (absAmount >= 10000) {
        return {
            displayAmount: (safeAmount / 10000).toFixed(2),
            displayUnit: "万元"
        };
    }

    return {
        displayAmount: safeAmount.toFixed(2),
        displayUnit: "元"
    };
}
